import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import Settings from './Settings';
import ChatData from "./Chat";
import Contact from "./Contact";
import Mail from "./Mail";
import ToDo from "./ToDo";
import Alerts from "./Alerts";
import Calendars from "./Calendars";


const reducers = combineReducers({
    routing: routerReducer,
    settings: Settings,
    chatData: ChatData,
    contacts: Contact,
    mail: Mail,
    toDo: ToDo,
    appAlerts: Alerts,
    calendars: Calendars
});

export default reducers;



// WEBPACK FOOTER //
// ./reducers/index.js